import { render, staticRenderFns } from "./exercisesEnclosure.vue?vue&type=template&id=4fea54d8&scoped=true"
import script from "./exercisesEnclosure.vue?vue&type=script&lang=js"
export * from "./exercisesEnclosure.vue?vue&type=script&lang=js"
import style0 from "./exercisesEnclosure.vue?vue&type=style&index=0&id=4fea54d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fea54d8",
  null
  
)

export default component.exports